import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { transformWorkflow } from '@/ai/utils/transformWorkflow'
import { readModelNotes } from '@/ai/prompts/common/instructions'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createSystemMessage, createUserMessage } from '@/ai/utils/promptUtils'

export const buildReadModelFromEntityPrompt = ({ workflow, entity }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  const { name: entityName, dataFields } = entity

  const entityFields = dataFields.map(({ name, exampleData }) => ({ name, exampleData }))

  const { events, entities } = transformWorkflow(workflow)

  promptSections.push({
    title: 'Request',
    content: `
      Generate a Read Model for the actor about to act on "${entityName}". In most of the cases the generated
      data fields should match with the data fields of the entity and include the primary key field (id) of the entity.
      An attribute can be a primitive or a reference to a non-primitive type like an associated entity.
      An attribute or field name must be in camel case format (e.g., 'productName' instead of 'Product Name').
      An attribute or field name must each be at most 30 characters long.
    `
  })

  promptSections.push({
    title: 'Current Workflow (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ domainEvents: events })
  })

  promptSections.push({
    title: 'Existing Entities (Optional): Use this information if applicable.',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ entities })
  })

  promptSections.push({
    title: 'Entity definition (data fields)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(entityFields)
  })

  const readModelExample = { readModel: examples.readModelExampleOrder }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('readModel', JSON.stringify(readModelExample))
  })

  promptSections.push({
    title: 'Note',
    contentType: 'bullet',
    content: [readModelNotes[0], readModelNotes[1]]
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
